import moment from 'moment';

export function a11yProps(index: number | string) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export function csvToArray(str: string, delimiter = ",") {
  const headers = str.slice(0, str.indexOf("\r\n")).split(delimiter);
  const rows = str.slice(str.indexOf("\n") + 1).split("\r\n");
  const arr = rows.map(function (row) {
    const values = row.split(delimiter);
    const el = headers.reduce(function (object: any, header, index) {
      object[header] = values[index];
      return object;
    }, {});
    return el;
  });
  return arr;
}

export function deleteQueryParamFromUrl(searchParams: URLSearchParams, searchParam: string) {
  searchParams.delete(searchParam);
  const queryString = searchParams.toString();
  const newUrl = queryString
    ? `${window.location.pathname}?${queryString}`
    : `${window.location.pathname}`;
  window.history.replaceState(null, '', newUrl);
}


export const findClosestYear = (years: string[]): string => {
  const currentYear = moment().year();
  return years.reduce((closest, year) => {
    const yearNum = parseInt(year, 10);
    const closestNum = parseInt(closest, 10);
    const currentDiff = Math.abs(yearNum - currentYear);
    const closestDiff = Math.abs(closestNum - currentYear);
    return currentDiff < closestDiff ? year : closest;
  });
};

export const capitaliseFirst = (text?: string): string => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const normaliseString = (value?: string): string => {
  if (!value) {
    return '';
  }
  return value
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
};